import { FunctionComponent, memo, useState } from "react";
import { IProps } from "./users-subscribed.types";
import UsersSubscribedTable from "./users-subscribed-table";
import useTagModels from "hooks-for/tags/use-tag-models";
import UsersSubscribedFilters from "./users-subscribed-filters";
import "./users-subscribed.scss";
import { IModel } from "@edgetier/watchtower-types";
import { SpinnerUntil } from "@edgetier/components";

/**
 * Display a table with all users subscribed to a tag
 * @param props.tagId Tag being
 */
const UsersSubscribed: FunctionComponent<IProps> = ({ tagId }) => {
    const { data: models, isLoading } = useTagModels(tagId);
    const [search, setSearch] = useState<string | null>(null);

    // Submit function for search filter
    const onSubmit = (searchValue: string) => {
        setSearch(searchValue !== "" ? searchValue.trim() : null);
    };

    return (
        <div className="users-subscribed">
            <UsersSubscribedFilters onSubmit={({ search }) => onSubmit(search)} />
            <SpinnerUntil<IModel[]> data={models} isReady={!isLoading}>
                {(data) => <UsersSubscribedTable modelId={data[0]?.modelId} search={search} tagId={tagId} />}
            </SpinnerUntil>
        </div>
    );
};

export default memo(UsersSubscribed);
